import React, { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";

const BookingConfirmation = () => {
  const { bookingData, setBookingData, serviceData } = useOutletContext();

  const [services, setServices] = useState([]);

  useEffect(() => {
    setServices(serviceData || []);
  }, [serviceData]);

  // This must be backtracked to the page with missing data -> future ma 
  const customer = bookingData?.customer || {};
  const vehicle = bookingData?.vehicle || {};
  const selectedDate = bookingData?.selectedDate || "";
  const selectedTime = bookingData?.selectedTime || "";
  const selectedServiceIds = bookingData?.selectedServices || [];

  const selectedServiceObjects = selectedServiceIds
    .map((id) => services.find((s) => s.id === id))
    .filter(Boolean);

  const resetBooking = () => {
    setBookingData({
      selectedServices: [],
      selectedDate: "",
      selectedTime: "",
      customer: { fullName: "", phone: "", email: "", notes: "" },
      vehicle: { make: "", model: "", year: "", odo: "", plate: "" },
    });
  };

  return (
    <section className="rounded-2xl bg-white p-6 shadow-sm">
      <h2 className="text-2xl font-semibold text-gray-900">
        Booking Confirmed!
      </h2>

      <div className="mt-6 rounded-xl border border-gray-200 bg-gray-50 p-5">
        <h3 className="text-sm font-semibold text-gray-900">
          Appointment Summary
        </h3>

        <div className="mt-4 grid gap-4 sm:grid-cols-2 text-sm">
          <div>
            <p className="text-xs font-semibold text-gray-500">Name</p>
            <p className="mt-1 font-medium text-gray-900">
              {customer.fullName || "—"}
            </p>
          </div>

          <div>
            <p className="text-xs font-semibold text-gray-500">Contact</p>
            <p className="mt-1 font-medium text-gray-900">
              {customer.phone || "—"} · {customer.email || "—"}
            </p>
          </div>

          <div>
            <p className="text-xs font-semibold text-gray-500">Vehicle</p>
            <p className="mt-1 font-medium text-gray-900">
              {vehicle.make || vehicle.model || vehicle.year
                ? `${vehicle.make || ""} ${vehicle.model || ""}${
                    vehicle.year ? ` · ${vehicle.year}` : ""
                  }`.trim()
                : "—"}
            </p>
          </div>

          <div>
            <p className="text-xs font-semibold text-gray-500">Date & Time</p>
            <p className="mt-1 font-medium text-gray-900">
              {selectedDate && selectedTime
                ? `${selectedDate} · ${selectedTime}`
                : "—"}
            </p>
          </div>
        </div>

        <div className="mt-6">
          <p className="text-xs font-semibold text-gray-500">Services</p>

          {selectedServiceObjects.length === 0 ? (

            // This line should be replaced with error handling for missing data -> logical error because bookin an app for no services makes no senseee
            <p className="mt-2 text-sm font-medium text-gray-900"> No Services Foud</p>
          ) : (
            <div className="mt-3 grid gap-3 sm:grid-cols-2">
              {selectedServiceObjects.map((service) => (
                <div
                  key={service.id}
                  className="flex items-center justify-between rounded-lg border border-gray-200 bg-white p-3 shadow-sm"
                >
                  <div>
                    <p className="text-sm font-semibold text-gray-900">
                      {service.name}
                    </p>
                    <p className="text-xs text-gray-500">
                      {service.time_taken} mins
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="mt-8 flex justify-between">
        <Link
          to="/"
          onClick={resetBooking}
          className="rounded-xl border border-gray-300 bg-white px-6 py-3 text-sm font-semibold text-gray-900 hover:bg-gray-50"
        >
          Back to Home
        </Link>

        <Link
          to="/services"
          onClick={resetBooking}
          className="rounded-xl bg-blue-600 px-6 py-3 text-sm font-semibold text-white hover:bg-blue-500"
        >
          View Services →
        </Link>
      </div>
    </section>
  );
};

export default BookingConfirmation;
